import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { Action, Separator, SubmenuAction } from '../../../base/common/actions.js';
import { createDecorator } from '../../instantiation/common/instantiation.js';
import { IContextKeyService } from '../../contextkey/common/contextkey.js';
import { ICommandService } from '../../commands/common/commands.js';
import { toDisposable } from '../../../base/common/lifecycle.js';
import { Emitter } from '../../../base/common/event.js';
import { Iterable } from '../../../base/common/iterator.js';
import { LinkedList } from '../../../base/common/linkedList.js';
export function isIMenuItem(item) {
  return item.command !== undefined;
}
export var MenuId = function MenuId(debugName) {
  _classCallCheck(this, MenuId);

  this.id = MenuId._idPool++;
  this._debugName = debugName;
};
MenuId._idPool = 0;
MenuId.CommandPalette = new MenuId('CommandPalette');
MenuId.EditorContext = new MenuId('EditorContext');
MenuId.EditorContextPeek = new MenuId('EditorContextPeek');
MenuId.MenubarEditMenu = new MenuId('MenubarEditMenu');
MenuId.MenubarGoMenu = new MenuId('MenubarGoMenu');
MenuId.MenubarSelectionMenu = new MenuId('MenubarSelectionMenu');
export var IMenuService = createDecorator('menuService');
export var MenuRegistry = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this._commands = new Map();
    this._menuItems = new Map();
    this._onDidChangeMenu = new Emitter();
    this.onDidChangeMenu = this._onDidChangeMenu.event;
    this._commandPaletteChangeEvent = {
      has: function has(id) {
        return id === MenuId.CommandPalette;
      }
    };
  }

  _createClass(_class, [{
    key: "addCommand",
    value: function addCommand(command) {
      return this.addCommands(Iterable.single(command));
    }
  }, {
    key: "addCommands",
    value: function addCommands(commands) {
      var _this = this;

      var _iterator = _createForOfIteratorHelper(commands),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var command = _step.value;

          this._commands.set(command.id, command);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._onDidChangeMenu.fire(this._commandPaletteChangeEvent);

      return toDisposable(function () {
        var didChange = false;

        var _iterator2 = _createForOfIteratorHelper(commands),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var command = _step2.value;
            didChange = _this._commands.delete(command.id) || didChange;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (didChange) {
          _this._onDidChangeMenu.fire(_this._commandPaletteChangeEvent);
        }
      });
    }
  }, {
    key: "getCommand",
    value: function getCommand(id) {
      return this._commands.get(id);
    }
  }, {
    key: "getCommands",
    value: function getCommands() {
      var map = new Map();

      this._commands.forEach(function (value, key) {
        return map.set(key, value);
      });

      return map;
    }
  }, {
    key: "appendMenuItem",
    value: function appendMenuItem(id, item) {
      return this.appendMenuItems(Iterable.single({
        id: id,
        item: item
      }));
    }
  }, {
    key: "appendMenuItems",
    value: function appendMenuItems(items) {
      var _this2 = this;

      var changedIds = new Set();
      var toRemove = new LinkedList();

      var _iterator3 = _createForOfIteratorHelper(items),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _step3.value,
              id = _step3$value.id,
              item = _step3$value.item;

          var list = this._menuItems.get(id);

          if (!list) {
            list = new LinkedList();

            this._menuItems.set(id, list);
          }

          toRemove.push(list.push(item));
          changedIds.add(id);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._onDidChangeMenu.fire(changedIds);

      return toDisposable(function () {
        if (toRemove.size > 0) {
          var _iterator4 = _createForOfIteratorHelper(toRemove),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var fn = _step4.value;
              fn();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          _this2._onDidChangeMenu.fire(changedIds);

          toRemove.clear();
        }
      });
    }
  }, {
    key: "getMenuItems",
    value: function getMenuItems(id) {
      var result;

      if (this._menuItems.has(id)) {
        result = _toConsumableArray(this._menuItems.get(id));
      } else {
        result = [];
      }

      if (id === MenuId.CommandPalette) {
        // CommandPalette is special because it shows
        // all commands by default
        this._appendImplicitItems(result);
      }

      return result;
    }
  }, {
    key: "_appendImplicitItems",
    value: function _appendImplicitItems(result) {
      var set = new Set();

      var _iterator5 = _createForOfIteratorHelper(result),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var item = _step5.value;

          if (isIMenuItem(item)) {
            set.add(item.command.id);

            if (item.alt) {
              set.add(item.alt.id);
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this._commands.forEach(function (command, id) {
        if (!set.has(id)) {
          result.push({
            command: command
          });
        }
      });
    }
  }]);

  return _class;
}())();

var ExecuteCommandAction = /*#__PURE__*/function (_Action) {
  _inherits(ExecuteCommandAction, _Action);

  var _super = _createSuper(ExecuteCommandAction);

  function ExecuteCommandAction(id, label, _commandService) {
    var _this3;

    _classCallCheck(this, ExecuteCommandAction);

    _this3 = _super.call(this, id, label);
    _this3._commandService = _commandService;
    return _this3;
  }

  _createClass(ExecuteCommandAction, [{
    key: "run",
    value: function run() {
      var _this$_commandService;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_this$_commandService = this._commandService).executeCommand.apply(_this$_commandService, [this.id].concat(args));
    }
  }]);

  return ExecuteCommandAction;
}(Action);

ExecuteCommandAction = __decorate([__param(2, ICommandService)], ExecuteCommandAction);
export { ExecuteCommandAction };
export var SubmenuItemAction = /*#__PURE__*/function (_SubmenuAction) {
  _inherits(SubmenuItemAction, _SubmenuAction);

  var _super2 = _createSuper(SubmenuItemAction);

  function SubmenuItemAction(item, menuService, contextKeyService, options) {
    var _this4;

    _classCallCheck(this, SubmenuItemAction);

    _this4 = _super2.call(this, "submenuitem.".concat(item.submenu.id), typeof item.title === 'string' ? item.title : item.title.value, function () {
      var result = [];
      var menu = menuService.createMenu(item.submenu, contextKeyService);
      var groups = menu.getActions(options);
      menu.dispose();

      var _iterator6 = _createForOfIteratorHelper(groups),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var group = _step6.value;

          var _group = _slicedToArray(group, 2),
              actions = _group[1];

          if (actions.length > 0) {
            result.push.apply(result, _toConsumableArray(actions));
            result.push(new Separator());
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      if (result.length) {
        result.pop(); // remove last separator
      }

      return result;
    }, 'submenu');
    _this4.item = item;
    return _this4;
  }

  return SubmenuItemAction;
}(SubmenuAction);

var MenuItemAction = /*#__PURE__*/function (_ExecuteCommandAction) {
  _inherits(MenuItemAction, _ExecuteCommandAction);

  var _super3 = _createSuper(MenuItemAction);

  function MenuItemAction(item, alt, options, contextKeyService, commandService) {
    var _this5;

    _classCallCheck(this, MenuItemAction);

    typeof item.title === 'string' ? _this5 = _super3.call(this, item.id, item.title, commandService) : _this5 = _super3.call(this, item.id, item.title.value, commandService);
    _this5._cssClass = undefined;
    _this5._enabled = !item.precondition || contextKeyService.contextMatchesRules(item.precondition);
    _this5._tooltip = item.tooltip ? typeof item.tooltip === 'string' ? item.tooltip : item.tooltip.value : undefined;

    if (item.toggled) {
      var toggled = item.toggled.condition ? item.toggled : {
        condition: item.toggled
      };
      _this5._checked = contextKeyService.contextMatchesRules(toggled.condition);

      if (_this5._checked && toggled.tooltip) {
        _this5._tooltip = typeof toggled.tooltip === 'string' ? toggled.tooltip : toggled.tooltip.value;
      }
    }

    _this5._options = options || {};
    _this5.item = item;
    _this5.alt = alt ? new MenuItemAction(alt, undefined, _this5._options, contextKeyService, commandService) : undefined;
    return _possibleConstructorReturn(_this5);
  }

  _createClass(MenuItemAction, [{
    key: "dispose",
    value: function dispose() {
      if (this.alt) {
        this.alt.dispose();
      }

      _get(_getPrototypeOf(MenuItemAction.prototype), "dispose", this).call(this);
    }
  }, {
    key: "run",
    value: function run() {
      var _get2;

      var runArgs = [];

      if (this._options.arg) {
        runArgs = [].concat(_toConsumableArray(runArgs), [this._options.arg]);
      }

      if (this._options.shouldForwardArgs) {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        runArgs = [].concat(_toConsumableArray(runArgs), args);
      }

      return (_get2 = _get(_getPrototypeOf(MenuItemAction.prototype), "run", this)).call.apply(_get2, [this].concat(_toConsumableArray(runArgs)));
    }
  }]);

  return MenuItemAction;
}(ExecuteCommandAction);

MenuItemAction = __decorate([__param(3, IContextKeyService), __param(4, ICommandService)], MenuItemAction);
export { MenuItemAction }; //#endregion